export const FILES_SUBMITTED = 'FILES_SUBMITTED';
export const FILE_UPLOAD_REQUEST_SUCCEEDED = 'FILE_UPLOAD_REQUEST_SUCCEEDED';
export const REMOVE_UPLOAD = 'REMOVE_UPLOAD';
export const REMOVE_COMPLETED_UPLOADS = 'REMOVE_COMPLETED_UPLOADS';
export const FILE_UPLOAD_ERROR_OCCURRED = 'FILE_UPLOAD_ERROR_OCCURRED';
export const PERCENT_COMPLETED_UPDATED = 'PERCENT_COMPLETED_UPDATED';
export const UPLOAD_STATUS_UPDATED = 'UPLOAD_STATUS_UPDATED';
export const FILE_UPLOAD_COMPLETED = 'FILE_UPLOAD_COMPLETED';
